<template>
    <div>
        <b-media v-for="(comment, index) in child_comments" :key="index">
            <b-img style="avatar-cmt" slot="aside" :src="comment.user.avatar500x500" height="44" width="44" />
            <a href="#">
                {{ comment.user ? comment.user.fullname : '' }}
                [{{ comment.user ? comment.user.email : '' }}]
            </a>
            <b-dropdown class="float-right" variant="transparent p-0" right v-if="comment.user.id === profile.id">
                <template slot="button-content">
                    <span class="link"><i class="fa fa-cog"></i> {{ $t('comment.action') }}</span>
                </template>
                <b-dropdown-item @click="update(comment)">
                    <i class="fa fa-pencil"></i>{{ $t('comment.update') }}</b-dropdown-item>
                <b-dropdown-item @click="destroy(comment)">
                    <i class="fa fa-trash"></i>{{ $t('comment.delete') }}</b-dropdown-item>
            </b-dropdown>
            <h6 class="small text-muted"><i class="fa fa-clock-o"></i> {{ comment.time }}</h6>
            <span v-html="comment.content"></span>
            <div class="row col-md-12">
                <div v-for="(image, index) in comment.images" :key="index">
                    <a v-if="comment.images[index] !== ''" :href="comment.images[index]" target="_blank">
                        <img v-if="comment.images_resize[index] !== ''" :src="comment.images_resize[index]"
                            class="img-fluid img-thumbnail m-2" width="100">
                    </a>
                </div>
            </div>
            <hr v-if="index + 1 < child_comments.length">
        </b-media>
        <b-media v-if="checkcomment()" class="mt-3">
            <b-img class="avatar-cmt" slot="aside" :src="profile.avatar500x500" width="44" height="44" />
            <textarea class="col-md-12 form-control" rows="2" v-model="cmt.content"
                :placeholder="$t('comment.write_comment')" @paste="handlePaste"></textarea>
            <error :error="errors.content"></error>
            <div class="row col-md-12">
                <div class="mt-3 mr-3" v-for="(img, index) in preview" :key="index">
                    <b-img :src="img" height="50" width="50" alt="placeholder" />
                    <h6 class="text-center link" @click="remove(index)"><i class="fa fa-trash"></i>
                        {{ $t('comment.remove') }}
                    </h6>
                    <error :error="errors['images.' + index]"></error>
                </div>
            </div>
            <span class="link" @click="openUploadImage">
                <i class="fa fa-picture-o"></i>
                {{ $t('comment.add_image') }}
            </span>
            <input type="file" class="form-control hidden" ref="files" :multiple="true" accept="image/*" @change="change">
            <div class="pull-right mt-2">
                <button class="btn btn-sm btn-primary" @click="reply()" :disabled="btn_submit"><i class="fa fa-paper-plane"></i>
                    {{ $t('comment.reply') }}
                </button>
            </div>
        </b-media>
        <child-edit-comment ref="edit_comment" @updateSuccess="updateSuccess"></child-edit-comment>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert'
import lodash from 'lodash'
import ChildEditComment from './edit-child-comment'

export default {
  name: 'child-comment',
  components: { ChildEditComment },
  props: ['comment', 'child_comments', 'checklist_item', 'comments'],
  data () {
    return {
      cmt: {
        content: ''
      },
      errors: {},
      open_upload_image: false,
      files: [],
      preview: [],
      btn_submit: false
    }
  },
  computed: {
    ...mapGetters({
      profile: 'Profile/getProfile'
    })
  },
  mounted () {

  },
  methods: {
    openUploadImage () {
      this.$refs.files.click()
    },
    handlePaste (event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items
      for (let item of items) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          const file = item.getAsFile()
          this.files.push(file)
          const reader = new FileReader()
          reader.onload = (e) => {
            this.preview.push(e.target.result)
          }
          reader.readAsDataURL(file)
        }
      }
    },
    reply () {
      const data = new FormData()
      data.append('content', this.cmt.content)
      data.append('parent_id', this.comment.id)
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        data.append('images[' + i + ']', file)
      }

      this.btn_submit = true
      this.$store.dispatch('Comment/createCommentOfChecklistItem', { checklist: { id: this.$route.params.checklist_id }, checklist_item: this.checklist_item, comment: data }).then(res => {
        this.child_comments.push(res)
        this.cmt = {
          content: ''
        }
        this.files = []
        this.preview = []

        this.checklist_item.no_cmt += 1
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
      })
    },
    change (event) {
      this.open_upload_image = false
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.files.files[i])
      }
    },
    remove (index) {
      this.files.splice(index, 1)
      this.preview.splice(index, 1)
      delete this.errors['images.' + index]
    },
    destroy (comment) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('Comment/destroyCommentOfChecklistItem', {
              checklist: { id: this.$route.params.checklist_id }, checklist_item: this.checklist_item, comment
            }).then((res) => {
              var index = lodash.findIndex(this.child_comments, ['id', comment.id])
              this.child_comments.splice(index, 1)
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.checklist_item.no_cmt -= 1
            }).catch(errors => {

            })
          }
        })
    },
    update (comment) {
      this.$refs.edit_comment.showModal(this.checklist_item, comment)
    },
    updateSuccess (comment) {
      var index = lodash.findIndex(this.comments, ['id', parseInt(comment.parent_id)])
      var childindex = lodash.findIndex(this.comments[index].children, ['id', comment.id])
      this.comments[index].children.splice(childindex, 1, comment)
      this.checklist_item.comments = this.comments
      this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
    },
    checkcomment () {
      if (parseInt(this.checklist_item.checklist_item_status.is_cmt)) {
        return true
      } else {
        return false
      }
    }
  }
}

</script>
<style lang="scss">
.avatar-cmt {
    border-radius: 50%;
    box-shadow: 0px 2px 2px #a9a9a9;
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/checklist-item/comment/child-comment/index.vue